import { Action, createAction } from 'redux-actions';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { mergeSaga } from '@/utils/redux-saga/merge-saga';
import { vipApi } from '@/utils/vip-api';
import { bannersReducer, BannersSliceType } from '../banners.reducer';
import { BannerDto } from '@/models/banner/banner.interface';

const suffix = `/${bannersReducer.sliceName}/app`;

const GET_BANNERS = `GET_BANNERS${suffix}`;

export const getBannersAction = createAction(GET_BANNERS);

const GET_BANNERS_SUCCESS = `GET_BANNERS_SUCCESS${suffix}`;
const getBannersSuccessAction = createAction<BannerDto[]>(GET_BANNERS_SUCCESS);

const GET_BANNERS_ERROR = `GET_BANNERS_ERROR${suffix}`;
const getBannersErrorAction = createAction<string>(GET_BANNERS_ERROR);

function* getBannersWatcher(): SagaIterator {
  yield takeEvery(GET_BANNERS, getBannersWorker);
}
mergeSaga(getBannersWatcher);

function* getBannersWorker(): SagaIterator {
  try {
    const res: BannerDto[] = yield call(getBannersApi);

    yield put(getBannersSuccessAction(res));
  } catch (e: any) {
    yield put(getBannersErrorAction(e));
  }
}

const getBannersApi = (): Request => {
  return vipApi(`/banners/public/list`, 'get', {});
};

const reduceHandlers = {
  [GET_BANNERS]: (slice: BannersSliceType): BannersSliceType => ({
    ...slice,
    isLoading: true,
  }),
  [GET_BANNERS_SUCCESS]: (slice: BannersSliceType, action: Action<BannerDto[]>): BannersSliceType => {
    return {
      ...slice,
      isLoading: false,
      banners: action.payload ?? [],
    };
  },
  [GET_BANNERS_ERROR]: (slice: BannersSliceType): BannersSliceType => ({
    ...slice,
    isLoading: false,
    banners: [],
  }),
};

bannersReducer.addActionReducerMap(reduceHandlers);
